// extracted by mini-css-extract-plugin
export default {"container":"CreateEstimatePrivateNotesTab_container__I23c5","title":"CreateEstimatePrivateNotesTab_title__WcAOR","formFooter":"CreateEstimatePrivateNotesTab_formFooter__9RTiy"};